import { AppField, File, SimpleRecord } from "@smartsuite/types";
import { useMemo } from "react";

import { getCoverImageFieldFilesFromRecord } from "../../../../../helpers/coverImage";

export interface LinkedRecordCoverImageProps {
  coverImageField?: AppField;
  record: SimpleRecord;
}

/**
 * Retrieves a linked record's cover images file based on the specified field and record information.
 *
 */
export const useLinkedRecordCoverImages = ({
  coverImageField,
  record,
}: LinkedRecordCoverImageProps): File[] => {
  return useMemo(() => {
    return getCoverImageFieldFilesFromRecord(coverImageField, record);
  }, [coverImageField, record]);
};
